<template>
  <div class="slo-product-image">
    <img :src="image.src" :alt="image.alt" class="h-auto" loading="lazy" width="233" height="233" />
  </div>
</template>

<script>
import {getImagesArray} from '../../js/main/utils';

const placeholder = {
  src: '/themes/sloan/img/product-placeholder.png',
  alt: ''
};

export default {
  name: 'SloProductImage',
  props: {
    source: {
      type: Array|null,
      default: () => []
    }
  },
  computed: {
    image() {
      return getImagesArray(this.source)[0] || placeholder;
    }
  }
};
</script>
